export default __webpack_public_path__ + "static/media/avenus-logo.607a8182.svg";